import React from "react";
//import logo from "./logo.svg";
import "./App.css";
import Layout from "./templates/Layout/Layout";
import { BrowserRouter as Router, Switch, Route, RouteProps, Redirect } from "react-router-dom";
import Login from "./pages/Login/Login";
import VendorAuth from "./pages/Vendor/VendorAuthentication/VendorAuthentication";
import { NavigationPaths } from "./constants/AppConstants";
import DashBoard from "./pages/Vendor/Dashboard/DashBoard";
import CallOverVerification from "./pages/Vendor/CallOverVerification/CallOverVerification";
import Test from "./pages/Test";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import VendorDetail from "./pages/Vendor/VendorDetail/VendorDetail";
import { AuthUtil } from "./utils/AuthUtil";
import { Common } from "./utils/Common";
import { UserLoginState } from "./reducers/LoginReducer";
import { common } from "@material-ui/core/colors";
import { useHistory } from "react-router-dom";
import { AxiosConfig, fileServiceConfig } from "./services/AxiosConfig";
import VendorBlocking from "./pages/Vendor/VendorBlocking/VendorBlocking";
import VendorRequest from "./pages/Vendor/VendorRequest/VendorRequest";
import SapVendorSearch from "./pages/Vendor/SapVendorSearch/SapVendorSearch";
import AccSubCategory from "./pages/MaterData/AccSubCategory/AccSubCategory";
import VendorTimeOut from "./pages/Vendor/VendorAuthentication/VendorTimeOut";
import { RoleUtil } from "./utils/RoleUtil";
import User from "./pages/MaterData/User/UserManagement";
import UserManagement from "./pages/MaterData/User/UserManagement";
import RoleManagement from "./pages/MaterData/Role/RoleManagement";
import VendorLogout from "./pages/Vendor/VendorAuthentication/VendorLogout";
import Report from "./pages/Report/Report";
import HistoryManagement from "./pages/History/HistoryManagement";
import UserHistoryManagement from "./pages/UserHistory/UserHistoryManagement";
import ProcurementCategory from "./pages/MaterData/ProcurementCategory/ProcurementCategory";
import VendorBlockExcemption from "./pages/Vendor/VendorBlockExcemption/VendorBlockExcemption";



const theme = createTheme ({

})

interface PrivateRouteProps extends RouteProps {
  // tslint:disable-next-line:no-any
  component: any;
}
//Added interceptors Test comment


const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, ...rest } = props;
  return (
      <Route
          {...rest}        
          render={(routeProps) =>              
            localStorage.getItem('loggedInUser')!=null ? (
                  <Component {...routeProps} {...rest} />
              ) : (                 
                      <Redirect
                          to={{
                              pathname: '/login',
                              hash: routeProps.location.hash,
                              state: { from: routeProps.location }
                          }}
                      />
                  )
          }
      />
  );
};

function App() {

  const history = useHistory();
  AxiosConfig.interceptors.request.use((request:any) => {
    //add api manager subscription
    
    request.headers['x-api-key'] = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
    //request.headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
    //request.headers['Access-Control-Allow-Origin'] = "https://azureapiqa.masholdings.com";
    //If get Access Token, then pass the refresh token
    if (request!==undefined && request.url.includes("Account/GetAccessToken")) {    
      request.headers["authorization"] = `Bearer ${AuthUtil.getRefreshToken()}`;
      return request;
    }
    else {   
      request.headers["authorization"] = `Bearer ${AuthUtil.getAuthHeaderTocken()}`;
      console.log(request);
      return request;
    }
  });

  fileServiceConfig.interceptors.request.use((request:any) => {
    //add api manager subscription
    
    //request.headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY;
    request.headers['x-api-key'] = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY;
   // request.headers['Access-Control-Allow-Origin'] = "https://azureapiqa.masholdings.com";
    return request;
  });
  
  
  
  AxiosConfig.interceptors.response.use((response:any) => {
    console.log(response);
    return response;
  },
 error => {
const originalRequest = error.config;
 
// No response received
// Example: CORS error / network error
if (!error.response) {
console.error("Network/CORS error:", error.message);
return Promise.reject(error);
}
 
// Response received, but it is not 401
if (error.response.status !== 401) {
return Promise.reject(error);
}
      else if (error.config.url.includes("Account/GetAccessToken")) {
        // Logout user if token refresh didn't work or user is disabled
        let isVendor = Common.isVendor();//get value befor clear local storage
        Common.clearLocalStorage();
        if(isVendor){
          window.location.replace(NavigationPaths.VendorTimeOut);
        }
        else {
          window.location.replace(NavigationPaths.Login);
        }
        //history.push(NavigationPaths.Login);
  
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
      else if (!originalRequest._retry) {
  
        // As the refresh request was not being returned, it wasn't part of the
        // promise chain. The callers .then / .catch would be called before the
        // token refresh had completed and you would still have the old token in
        // localStorage.
        var loggedUser: UserLoginState = JSON.parse(Common.getLoginUserData() || '{}');
        if (loggedUser !== undefined) {
  
          const refershToken: string = loggedUser.refreshToken;
  
          originalRequest._retry = true;
  
          return AxiosConfig.post("Account/GetAccessToken",
            {
              headers: {
                'authorization': `Bearer ${refershToken}`
              }
            }
          )
            .then((response: any) => {
              Common.RefreshAccessToken(response.data.accessToken);
  
              // Still need to return the an error because the original request failed
              // but added a property to show it can be tried again.
              error.hasRefreshedToken = true;
              return AxiosConfig(originalRequest);
            })
            .catch(() => {
              const tokenError = new Error("Cannot refresh token");
              //  tokenError.originalError = error;
              return Promise.reject(tokenError);
            });
        }
      }
    });
  return (
    <ThemeProvider theme={theme}>
    <Router>
    <div className="App">
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/VendorAuth/:token" component={VendorAuth} />
            <Route exact path="/VendorAuth" component={VendorAuth} />
            <Route
                  exact
                  path={NavigationPaths.VendorLogout}
                  component={VendorLogout}
                />
            <Route
                  exact
                  path={NavigationPaths.VendorTimeOut}
                  component={VendorTimeOut}
                />
            <Layout>
                <PrivateRoute
                  exact
                  path={NavigationPaths.Dashboard}
                  component={DashBoard}
                />
                <PrivateRoute
                  exact
                  path={NavigationPaths.SapVendorSearch}
                  component={SapVendorSearch}
                />
                <PrivateRoute
                  exact
                  path={NavigationPaths.VendorRequest}
                  component={VendorRequest}
                />
                  <PrivateRoute
                  exact
                  path={NavigationPaths.VendorDetail}
                  component={VendorDetail}
                />
                  <PrivateRoute
                  exact
                  path={NavigationPaths.CallOverVerification}
                  component={CallOverVerification}
                />
                {/* <PrivateRoute
                  exact
                  path={NavigationPaths.VendorExtend}
                  component={VendorExtend}
                /> */}
                 <PrivateRoute
                   exact
                   path={NavigationPaths.VendorBlocking}
                   component={VendorBlocking}
                 />
                  <PrivateRoute
                  exact
                  path={NavigationPaths.AccSubCategory}
                  component={AccSubCategory}
                />
                <PrivateRoute
                  exact
                  path={NavigationPaths.UserManagement}
                  component={UserManagement}
                /> 
                <PrivateRoute
                  exact
                  path={NavigationPaths.RoleManagement}
                  component={RoleManagement}
                />
                <PrivateRoute
                  exact
                  path={NavigationPaths.Report}
                  component={Report}
                />
                 <PrivateRoute
                  exact
                  path={NavigationPaths.HistoryManagement}
                  component={HistoryManagement}
                />
                <PrivateRoute
                  exact
                  path={NavigationPaths.UserHistoryManagement}
                  component={UserHistoryManagement}
                />
                 <PrivateRoute
                  exact
                  path={NavigationPaths.ProcurementCategory}
                  component={ProcurementCategory}
                />
                 <PrivateRoute
                  exact
                  path={NavigationPaths.VendorBlockExcemption}
                  component={VendorBlockExcemption}
                />
            </Layout>
          </Switch>
    </div>
    </Router>
      </ThemeProvider>
  );
}

export default App;
